export default __webpack_public_path__ + "static/media/rug.507a36bd.jpg";